// extracted by mini-css-extract-plugin
module.exports = {"Post__tool":"ZkB8","Post__tool_icon":"EJDJ"};